import muiIcons from "../../../components/icons/mui-icons";

export const sideTitleCardData = [
  {
    Icon: muiIcons.DownloadIcon,
    subtitle: "Today's Upload",
    title: "21",
  },
  {
    Icon: muiIcons.PersonIcon,
    subtitle: "New Users",
    title: "53",
  },
  {
    Icon: muiIcons.MoneyIcon,
    subtitle: "Total Sales",
    title: "4031",
  },
  {
    Icon: muiIcons.MoneyIcon,
    subtitle: "Total Earning",
    title: "4031",
  },
  {
    Icon: muiIcons.SettingIcon,
    subtitle: "Today Servicing",
    title: "301",
  },
  {
    Icon: muiIcons.NotificationsIcon,
    subtitle: "Today Notification",
    title: "401",
  },
];

export const topAuthorList = [
  {
    name: "David Hopkins",
    description: "Lorem ipsum dolor sit amet consectetur.",
    photoUrl: "/assets/images/faces/2.jpg",
  },
  {
    name: "James Mitchell",
    description: "Lorem ipsum dolor sit amet consectetur.",
    photoUrl: "/assets/images/faces/3.jpg",
  },
  {
    name: "Jessica Mitchell",
    description: "Lorem ipsum dolor sit amet consectetur.",
    photoUrl: "/assets/images/faces/4.jpg",
  },
];
